// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ============ palette & tokens ============ */
/* ============ page ============ */
.ticket-chat-page {
  max-width: 440px;
  margin: 0 auto;
  padding: 0;
  box-sizing: border-box;
  height: 100vh;
  height: var(--ticket-chat-viewport-height, 100dvh);
  min-height: 100vh;
  min-height: var(--ticket-chat-viewport-height, 100dvh);
  background: #f7f9fa;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ============ header ============ */
.ticket-chat-header {
  position: sticky;
  top: 0;
  background: #ffffff;
  z-index: 20;
  border-radius: 0 0 22px 22px;
  box-shadow: 0 6px 24px rgba(36, 41, 57, 0.08);
  margin-bottom: 7px;
  /* легкая линия под шапкой */
}
.ticket-chat-header:after {
  content: "";
  display: block;
  height: 1px;
  background: linear-gradient(90deg, transparent, #ededf5, transparent);
  opacity: 0.9;
}

.ticket-chat-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 18px 0 18px;
  min-height: 49px;
  gap: 10px;
}

.ticket-chat-title {
  font-size: 1.09rem;
  font-weight: 700;
  color: #232137;
  line-height: 1.17;
  flex: 1 1;
}

.ticket-chat-status {
  font-size: 0.98rem;
  font-weight: 600;
  padding: 3px 13px 3px 10px;
  border-radius: 12px;
  color: #fff;
  background: #e72f44;
  min-width: 72px;
  text-align: center;
  letter-spacing: 0.01em;
}
.ticket-chat-status.status-waiting {
  background: #ffe066;
  color: #232137;
}
.ticket-chat-status.status-closed {
  background: #bfc2d1;
  color: #fff;
}

.ticket-chat-rating {
  display: grid;
  gap: 9px;
  margin: 0 8px 8px 8px;
  padding: 10px 12px;
  border: 1px solid #ffd7a3;
  border-radius: 16px;
  background: #fff8ed;
  box-shadow: 0 2px 12px rgba(36, 41, 57, 0.06);
}

.ticket-chat-rating-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.ticket-chat-rating-title span,
.ticket-chat-rating-note {
  color: #8a5200;
  font-size: 0.88rem;
  line-height: 1.25;
}

.ticket-chat-rating-title strong {
  color: #5d3700;
  white-space: nowrap;
}

.ticket-chat-rating-buttons {
  display: grid;
  grid-template-columns: repeat(5, minmax(38px, 1fr));
  gap: 7px;
}

.ticket-chat-rating-buttons button {
  min-height: 38px;
  border: 1px solid #f3a329;
  border-radius: 12px;
  background: #fff;
  color: #8a5200;
  font-weight: 800;
}

.ticket-chat-rating-buttons button.active,
.ticket-chat-rating-buttons button:active {
  background: #f3a329;
  color: #fff;
}

.ticket-chat-rating-buttons button:disabled {
  opacity: 0.62;
}

.ticket-chat-rating-comment {
  width: 100%;
  min-height: 76px;
  resize: vertical;
  border: 1px solid #ffd7a3;
  border-radius: 10px;
  padding: 9px 10px;
  background: #fff;
  color: #332616;
  font: inherit;
}

.ticket-chat-rating-comment:disabled {
  opacity: 0.7;
}

.ticket-chat-rating-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.ticket-chat-rating-footer span {
  color: #8a5200;
  font-size: 0.78rem;
}

.ticket-chat-rating-submit {
  min-height: 36px;
  border: 0;
  border-radius: 10px;
  padding: 0 14px;
  background: #f3a329;
  color: #fff;
  font-weight: 800;
}

.ticket-chat-rating-submit:disabled {
  opacity: 0.62;
}

.ticket-chat-rating-readonly {
  margin: 0;
  padding: 9px 10px;
  border-radius: 10px;
  background: #fff;
  color: #4f3a1d;
  white-space: pre-wrap;
}

/* ============ list ============ */
.ticket-chat-messages {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 0 7px 18px 7px;
  display: flex;
  flex-direction: column;
  gap: 9px;
  scroll-behavior: smooth;
  scroll-padding-bottom: 96px;
  /* тонкий скролл */
}
.ticket-chat-messages::-webkit-scrollbar {
  width: 8px;
}
.ticket-chat-messages::-webkit-scrollbar-thumb {
  background: #e0e2ef;
  border-radius: 8px;
}
.ticket-chat-messages::-webkit-scrollbar-track {
  background: transparent;
}

/* ============ message ============ */
.ticket-chat-message {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 96%;
  animation: bubble-pop 0.18s ease-out both;
}

.ticket-chat-message.user {
  align-items: flex-end;
}

.message-bubble {
  background: #ffffff;
  color: #232137;
  font-size: 1.05rem;
  padding: 11px 14px;
  border-radius: 17px 17px 6px 17px;
  box-shadow: 0 2px 12px rgba(36, 41, 57, 0.06);
  max-width: 86vw;
  word-break: break-word;
  margin-bottom: 6px;
  white-space: pre-line;
  border: 1px solid #eef0f6;
}
.message-bubble a {
  color: #e72f44;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.ticket-chat-message.user .message-bubble {
  background: linear-gradient(93deg, #f8e1ea 7%, #ffe6ef 94%);
  color: #e72f44;
  border-radius: 17px 17px 17px 7px;
  border: 1px solid #ffd4e2;
}

.message-date {
  font-size: 0.89rem;
  color: #bfc2d1;
  margin-left: 7px;
  margin-right: 7px;
}

.ticket-chat-message.user .message-date {
  color: #e7b5be;
}

/* ============ empty & error ============ */
.ticket-chat-empty {
  margin: 16px auto;
  color: #8f94a6;
  font-size: 0.98rem;
}
.ticket-chat-empty.error {
  color: #d84b5a;
  background: #fff2f4;
  border: 1px solid #ffd6dc;
  padding: 8px 12px;
  border-radius: 10px;
}

/* ============ attachments ============ */
/* Правило: если картинка — превью + ссылка ниже.
   Иначе — только ссылка-кнопка. */
.message-attachments {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin: -2px 0 2px 0; /* ближе к бабблу */
  /* 2 столбца для нескольких картинок */
}
@media (min-width: 420px) {
  .message-attachments {
    grid-template-columns: repeat(2, 1fr);
  }
}

.message-attach {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.message-attach-thumb-wrap {
  display: block;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(36, 41, 57, 0.06);
  border: 1px solid #eef0f6;
  background: #fff;
  transition: transform 0.12s ease, box-shadow 0.12s ease;
}
.message-attach-thumb-wrap:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(36, 41, 57, 0.09);
}

.message-attach-thumb {
  width: 100%;
  height: 190px;
  object-fit: cover;
  display: block;
  background: #f3f5f8;
}

/* подпись-ссылка под превью */
.message-attach-link-only {
  margin-top: 6px;
}
.message-attach-link-only a {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #e72f44;
  font-weight: 600;
  text-decoration: none;
  padding: 6px 8px;
  border-radius: 10px;
}
.message-attach-link-only a:hover {
  text-decoration: underline;
  text-underline-offset: 2px;
}

/* ссылка для не-картинок — визуальная «пилюля» */
.ticket-chat-message .message-attach-link-only--file a {
  background: #fff;
  border: 1px solid #eef0f6;
  box-shadow: 0 2px 12px rgba(36, 41, 57, 0.06);
  color: #232137;
}
.ticket-chat-message .message-attach-link-only--file a:before {
  content: "📎";
  font-size: 1rem;
}
.ticket-chat-message .message-attach-link-only--file a:hover {
  color: #e72f44;
  border-color: #ffd4e2;
}

/* ============ input row ============ */
.ticket-chat-input-row {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 9px 10px 10px 10px;
  background: #ffffff;
  border: 1px solid #ededf5;
  border-radius: 20px;
  box-shadow: 0 -1px 14px rgba(36, 41, 57, 0.08);
  position: relative;
  z-index: 30;
  margin: 0 8px calc(8px + env(safe-area-inset-bottom, 0px)) 8px;
  gap: 8px;
}

.ticket-chat-compose-line {
  display: flex;
  align-items: flex-end;
  gap: 9px;
}

.ticket-chat-input {
  flex: 1 1;
  min-width: 0;
  min-height: 44px;
  max-height: 92px;
  font-size: 1rem;
  line-height: 1.25;
  border-radius: 14px;
  border: 1px solid #e0e2ef;
  padding: 11px 12px;
  outline: none;
  transition: border 0.14s, background 0.14s, box-shadow 0.14s;
  font-family: "Cera Pro", Arial, sans-serif;
  color: #232137;
  background: #f7f9fa;
  resize: none;
  overflow-y: auto;
  box-sizing: border-box;
}
.ticket-chat-input:focus {
  border: 1.5px solid #e72f44;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(231, 47, 68, 0.08);
}

.ticket-chat-send-btn {
  background: #e72f44;
  color: #fff;
  min-width: 92px;
  height: 44px;
  font-size: 0.95rem;
  font-weight: 700;
  border: none;
  border-radius: 11px;
  padding: 0 12px;
  cursor: pointer;
  transition: transform 0.06s ease, background 0.13s;
}
.ticket-chat-send-btn:hover {
  transform: translateY(-1px);
}
.ticket-chat-send-btn:active {
  transform: translateY(0);
}
.ticket-chat-send-btn:disabled {
  background: #d4a3af;
  cursor: default;
  transform: none;
}

.ticket-chat-attach-btn {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e0e2ef;
  border-radius: 13px;
  background: #f7f9fa;
  color: #e72f44;
  font-size: 1.45rem;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}
.ticket-chat-attach-btn:disabled {
  color: #d4a3af;
  cursor: default;
}

.ticket-chat-selected-files {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ticket-chat-selected-file {
  max-width: 100%;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 8px;
  border-radius: 10px;
  background: #fff4f7;
  border: 1px solid #ffd4e2;
  color: #232137;
  font-size: 0.86rem;
}
.ticket-chat-selected-file span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ticket-chat-selected-file button {
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 50%;
  background: #fff;
  color: #e72f44;
  font-weight: 700;
  cursor: pointer;
}

/* ============ micro animations ============ */
@keyframes bubble-pop {
  from {
    transform: translateY(4px) scale(0.98);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
/* ============ utilities ============ */
/* компактнее на низких экранах */
@media (max-height: 680px) {
  .message-attach-thumb {
    height: 160px;
  }
}
@media (max-width: 480px) {
  .ticket-chat-input-row {
    margin-bottom: calc(12px + max(env(safe-area-inset-bottom, 0px), 18px));
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/OrderLayoutPage/ticketChat.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,+CAAA;AAeA,mCAAA;AACA;EACE,gBAAA;EACA,cAAA;EACA,UAAA;EACA,sBAAA;EACA,aAAA;EACA,kDAAA;EACA,iBAAA;EACA,sDAAA;EACA,mBAnBG;EAoBH,aAAA;EACA,sBAAA;EACA,gBAAA;AAZF;;AAeA,qCAAA;AACA;EACE,gBAAA;EACA,MAAA;EACA,mBA9BM;EA+BN,WAAA;EACA,4BAAA;EACA,6CAzBS;EA0BT,kBAAA;EAEA,4BAAA;AAbF;AAcE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,qEAAA;EACA,YAAA;AAZJ;;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;EACA,gBAAA;EACA,SAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,gBAAA;EACA,cA5DI;EA6DJ,iBAAA;EACA,SAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAzEM;EA0EN,eAAA;EACA,kBAAA;EACA,sBAAA;AAbF;AAeE;EAAmB,mBAAA;EAAqB,cA5EpC;AAiEN;AAYE;EAAmB,mBAAA;EAAqB,WAAA;AAR1C;;AAWA;EACE,aAAA;EACA,QAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6CA/ES;AAuEX;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AARF;;AAWA;;EAEE,cAAA;EACA,kBAAA;EACA,iBAAA;AARF;;AAWA;EACE,cAAA;EACA,mBAAA;AARF;;AAWA;EACE,aAAA;EACA,mDAAA;EACA,QAAA;AARF;;AAWA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AARF;;AAWA;;EAEE,mBAAA;EACA,WAAA;AARF;;AAWA;EACE,aAAA;AARF;;AAWA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AARF;;AAWA;EACE,cAAA;EACA,kBAAA;AARF;;AAWA;EACE,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AARF;;AAWA;EACE,aAAA;AARF;;AAWA;EACE,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AARF;;AAWA,mCAAA;AACA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;EACA,2BAAA;EAEA,kBAAA;AATF;AAUE;EAAuB,UAAA;AAPzB;AAQE;EACE,mBAAA;EACA,kBAAA;AANJ;AAQE;EAA6B,uBAAA;AAL/B;;AAQA,sCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,yCAAA;AALF;;AAQA;EACE,qBAAA;AALF;;AAQA;EACE,mBA3NM;EA4NN,cA9NI;EA+NJ,kBAAA;EACA,kBAAA;EACA,iCAAA;EACA,6CAzNS;EA0NT,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AALF;AAOE;EACE,cA5OI;EA6OJ,0BAAA;EACA,0BAAA;AALJ;;AASA;EACE,2DAAA;EACA,cApPM;EAqPN,iCAAA;EACA,yBAAA;AANF;;AASA;EACE,kBAAA;EACA,cAxPM;EAyPN,gBAAA;EACA,iBAAA;AANF;;AASA;EACE,cAAA;AANF;;AASA,4CAAA;AACA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;AANF;AAQE;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;AANJ;;AAUA,0CAAA;AACA;kCAAA;AAGA;EACE,WAAA;EACA,aAAA;EACA,0BAAA;EACA,QAAA;EACA,oBAAA,EAAA,mBAAA;EAEA,sCAAA;AATF;AAUE;EARF;IASI,qCAAA;EAPF;AACF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;AAPF;;AAUA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAnSS;EAoST,yBAAA;EACA,gBAAA;EACA,uDAAA;AAPF;AASE;EACE,2BAAA;EACA,6CAAA;AAPJ;;AAWA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AARF;;AAWA,8BAAA;AACA;EACE,eAAA;AARF;AAUE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAzUI;EA0UJ,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AARJ;AAUI;EACE,0BAAA;EACA,0BAAA;AARN;;AAaA,iDAAA;AACA;EACE,gBAAA;EACA,yBAAA;EACA,6CA/US;EAgVT,cAzVI;AA+UN;AAYE;EACE,aAAA;EACA,eAAA;AAVJ;AAaE;EACE,cAnWI;EAoWJ,qBAAA;AAXJ;;AAeA,wCAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBA1WM;EA2WN,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,kBAAA;EACA,WAAA;EACA,8DAAA;EACA,QAAA;AAZF;;AAeA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;AAZF;;AAeA;EACE,SAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,4DAAA;EACA,0CAAA;EACA,cAzYI;EA0YJ,mBAvYG;EAwYH,YAAA;EACA,gBAAA;EACA,sBAAA;AAZF;AAcE;EACE,2BAAA;EACA,gBAAA;EACA,6CAAA;AAZJ;;AAgBA;EACE,mBAzZM;EA0ZN,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kDAAA;AAbF;AAeE;EAAU,2BAAA;AAZZ;AAaE;EAAW,wBAAA;AAVb;AAYE;EACE,mBAAA;EACA,eAAA;EACA,eAAA;AAVJ;;AAcA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAnbG;EAobH,cAzbM;EA0bN,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAXF;AAaE;EACE,cAAA;EACA,eAAA;AAXJ;;AAeA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAZF;;AAeA;EACE,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAldI;EAmdJ,kBAAA;AAZF;AAcE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAZJ;AAeE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAneI;EAoeJ,gBAAA;EACA,eAAA;AAbJ;;AAiBA,+CAAA;AACA;EACE;IAAO,sCAAA;IAAuC,UAAA;EAZ9C;EAaA;IAAO,iCAAA;IAAsC,UAAA;EAT7C;AACF;AAWA,wCAAA;AACA,iCAAA;AACA;EACE;IAAwB,aAAA;EARxB;AACF;AAUA;EACE;IACE,uEAAA;EARF;AACF","sourcesContent":["/* ============ palette & tokens ============ */\r\n$brand: #e72f44;\r\n$brand-soft: #ffe6ef;\r\n$ink: #232137;\r\n$muted: #bfc2d1;\r\n$paper: #ffffff;\r\n$bg: #f7f9fa;\r\n\r\n$radius-lg: 22px;\r\n$radius-md: 17px;\r\n$radius-sm: 12px;\r\n\r\n$shadow-1: 0 2px 12px rgba(36, 41, 57, .06);\r\n$shadow-2: 0 6px 24px rgba(36, 41, 57, .08);\r\n\r\n/* ============ page ============ */\r\n.ticket-chat-page {\n  max-width: 440px;\n  margin: 0 auto;\n  padding: 0;\n  box-sizing: border-box;\n  height: 100vh;\n  height: var(--ticket-chat-viewport-height, 100dvh);\n  min-height: 100vh;\n  min-height: var(--ticket-chat-viewport-height, 100dvh);\n  background: $bg;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\r\n/* ============ header ============ */\r\n.ticket-chat-header {\r\n  position: sticky;\r\n  top: 0;\r\n  background: $paper;\r\n  z-index: 20;\r\n  border-radius: 0 0 $radius-lg $radius-lg;\r\n  box-shadow: $shadow-2;\r\n  margin-bottom: 7px;\r\n\r\n  /* легкая линия под шапкой */\r\n  &:after {\r\n    content: \"\";\r\n    display: block;\r\n    height: 1px;\r\n    background: linear-gradient(90deg, transparent, #ededf5, transparent);\r\n    opacity: .9;\r\n  }\r\n}\r\n\r\n.ticket-chat-title-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 9px 18px 0 18px;\r\n  min-height: 49px;\r\n  gap: 10px;\r\n}\r\n\r\n.ticket-chat-title {\r\n  font-size: 1.09rem;\r\n  font-weight: 700;\r\n  color: $ink;\r\n  line-height: 1.17;\r\n  flex: 1;\r\n}\r\n\r\n.ticket-chat-status {\n  font-size: .98rem;\n  font-weight: 600;\n  padding: 3px 13px 3px 10px;\r\n  border-radius: 12px;\r\n  color: #fff;\r\n  background: $brand;\r\n  min-width: 72px;\r\n  text-align: center;\r\n  letter-spacing: .01em;\r\n\r\n  &.status-waiting { background: #ffe066; color: $ink; }\r\n  &.status-closed  { background: #bfc2d1; color: #fff;  }\n}\n\n.ticket-chat-rating {\n  display: grid;\n  gap: 9px;\n  margin: 0 8px 8px 8px;\n  padding: 10px 12px;\n  border: 1px solid #ffd7a3;\n  border-radius: 16px;\n  background: #fff8ed;\n  box-shadow: $shadow-1;\n}\n\n.ticket-chat-rating-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.ticket-chat-rating-title span,\n.ticket-chat-rating-note {\n  color: #8a5200;\n  font-size: .88rem;\n  line-height: 1.25;\n}\n\n.ticket-chat-rating-title strong {\n  color: #5d3700;\n  white-space: nowrap;\n}\n\n.ticket-chat-rating-buttons {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(38px, 1fr));\n  gap: 7px;\n}\n\n.ticket-chat-rating-buttons button {\n  min-height: 38px;\n  border: 1px solid #f3a329;\n  border-radius: 12px;\n  background: #fff;\n  color: #8a5200;\n  font-weight: 800;\n}\n\n.ticket-chat-rating-buttons button.active,\n.ticket-chat-rating-buttons button:active {\n  background: #f3a329;\n  color: #fff;\n}\n\n.ticket-chat-rating-buttons button:disabled {\n  opacity: .62;\n}\n\n.ticket-chat-rating-comment {\n  width: 100%;\n  min-height: 76px;\n  resize: vertical;\n  border: 1px solid #ffd7a3;\n  border-radius: 10px;\n  padding: 9px 10px;\n  background: #fff;\n  color: #332616;\n  font: inherit;\n}\n\n.ticket-chat-rating-comment:disabled {\n  opacity: .7;\n}\n\n.ticket-chat-rating-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.ticket-chat-rating-footer span {\n  color: #8a5200;\n  font-size: .78rem;\n}\n\n.ticket-chat-rating-submit {\n  min-height: 36px;\n  border: 0;\n  border-radius: 10px;\n  padding: 0 14px;\n  background: #f3a329;\n  color: #fff;\n  font-weight: 800;\n}\n\n.ticket-chat-rating-submit:disabled {\n  opacity: .62;\n}\n\n.ticket-chat-rating-readonly {\n  margin: 0;\n  padding: 9px 10px;\n  border-radius: 10px;\n  background: #fff;\n  color: #4f3a1d;\n  white-space: pre-wrap;\n}\n\n/* ============ list ============ */\n.ticket-chat-messages {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0 7px 18px 7px;\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n  scroll-behavior: smooth;\n  scroll-padding-bottom: 96px;\n\r\n  /* тонкий скролл */\r\n  &::-webkit-scrollbar { width: 8px; }\r\n  &::-webkit-scrollbar-thumb {\r\n    background: #e0e2ef;\r\n    border-radius: 8px;\r\n  }\r\n  &::-webkit-scrollbar-track { background: transparent; }\r\n}\r\n\r\n/* ============ message ============ */\r\n.ticket-chat-message {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  max-width: 96%;\r\n  animation: bubble-pop .18s ease-out both;\r\n}\r\n\r\n.ticket-chat-message.user {\r\n  align-items: flex-end;\r\n}\r\n\r\n.message-bubble {\r\n  background: $paper;\r\n  color: $ink;\r\n  font-size: 1.05rem;\r\n  padding: 11px 14px;\r\n  border-radius: $radius-md $radius-md 6px $radius-md;\r\n  box-shadow: $shadow-1;\r\n  max-width: 86vw;\r\n  word-break: break-word;\r\n  margin-bottom: 6px;\r\n  white-space: pre-line;\r\n  border: 1px solid #eef0f6;\r\n\r\n  a {\r\n    color: $brand;\r\n    text-decoration: underline;\r\n    text-underline-offset: 2px;\r\n  }\r\n}\r\n\r\n.ticket-chat-message.user .message-bubble {\r\n  background: linear-gradient(93deg, #f8e1ea 7%, $brand-soft 94%);\r\n  color: $brand;\r\n  border-radius: $radius-md $radius-md $radius-md 7px;\r\n  border: 1px solid #ffd4e2;\r\n}\r\n\r\n.message-date {\r\n  font-size: .89rem;\r\n  color: $muted;\r\n  margin-left: 7px;\r\n  margin-right: 7px;\r\n}\r\n\r\n.ticket-chat-message.user .message-date {\r\n  color: #e7b5be;\r\n}\r\n\r\n/* ============ empty & error ============ */\r\n.ticket-chat-empty {\r\n  margin: 16px auto;\r\n  color: #8f94a6;\r\n  font-size: .98rem;\r\n\r\n  &.error {\r\n    color: #d84b5a;\r\n    background: #fff2f4;\r\n    border: 1px solid #ffd6dc;\r\n    padding: 8px 12px;\r\n    border-radius: 10px;\r\n  }\r\n}\r\n\r\n/* ============ attachments ============ */\r\n/* Правило: если картинка — превью + ссылка ниже.\r\n   Иначе — только ссылка-кнопка. */\r\n\r\n.message-attachments {\r\n  width: 100%;\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 8px;\r\n  margin: -2px 0 2px 0; /* ближе к бабблу */\r\n\r\n  /* 2 столбца для нескольких картинок */\r\n  @media (min-width: 420px) {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n}\r\n\r\n.message-attach {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n}\r\n\r\n.message-attach-thumb-wrap {\r\n  display: block;\r\n  border-radius: 14px;\r\n  overflow: hidden;\r\n  box-shadow: $shadow-1;\r\n  border: 1px solid #eef0f6;\r\n  background: #fff;\r\n  transition: transform .12s ease, box-shadow .12s ease;\r\n\r\n  &:hover {\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 6px 18px rgba(36,41,57,.09);\r\n  }\r\n}\r\n\r\n.message-attach-thumb {\r\n  width: 100%;\r\n  height: 190px;\r\n  object-fit: cover;\r\n  display: block;\r\n  background: #f3f5f8;\r\n}\r\n\r\n/* подпись-ссылка под превью */\r\n.message-attach-link-only {\r\n  margin-top: 6px;\r\n\r\n  a {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    color: $brand;\r\n    font-weight: 600;\r\n    text-decoration: none;\r\n    padding: 6px 8px;\r\n    border-radius: 10px;\r\n\r\n    &:hover {\r\n      text-decoration: underline;\r\n      text-underline-offset: 2px;\r\n    }\r\n  }\r\n}\r\n\r\n/* ссылка для не-картинок — визуальная «пилюля» */\r\n.ticket-chat-message .message-attach-link-only--file a {\r\n  background: #fff;\r\n  border: 1px solid #eef0f6;\r\n  box-shadow: $shadow-1;\r\n  color: $ink;\r\n\r\n  &:before {\r\n    content: \"📎\";\r\n    font-size: 1rem;\r\n  }\r\n\r\n  &:hover {\r\n    color: $brand;\r\n    border-color: #ffd4e2;\r\n  }\r\n}\r\n\r\n/* ============ input row ============ */\r\n.ticket-chat-input-row {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  padding: 9px 10px 10px 10px;\n  background: $paper;\n  border: 1px solid #ededf5;\n  border-radius: 20px;\n  box-shadow: 0 -1px 14px rgba(36,41,57,.08);\n  position: relative;\n  z-index: 30;\n  margin: 0 8px calc(8px + env(safe-area-inset-bottom, 0px)) 8px;\n  gap: 8px;\n}\n\n.ticket-chat-compose-line {\n  display: flex;\n  align-items: flex-end;\n  gap: 9px;\n}\n\n.ticket-chat-input {\n  flex: 1;\n  min-width: 0;\n  min-height: 44px;\n  max-height: 92px;\n  font-size: 1rem;\n  line-height: 1.25;\n  border-radius: 14px;\n  border: 1px solid #e0e2ef;\n  padding: 11px 12px;\n  outline: none;\n  transition: border .14s, background .14s, box-shadow .14s;\n  font-family: 'Cera Pro', Arial, sans-serif;\n  color: $ink;\n  background: $bg;\n  resize: none;\n  overflow-y: auto;\n  box-sizing: border-box;\n\n  &:focus {\n    border: 1.5px solid $brand;\r\n    background: #fff;\r\n    box-shadow: 0 0 0 3px rgba(231, 47, 68, .08);\r\n  }\r\n}\r\n\r\n.ticket-chat-send-btn {\n  background: $brand;\n  color: #fff;\n  min-width: 92px;\n  height: 44px;\n  font-size: .95rem;\n  font-weight: 700;\n  border: none;\n  border-radius: 11px;\n  padding: 0 12px;\n  cursor: pointer;\n  transition: transform .06s ease, background .13s;\n\r\n  &:hover { transform: translateY(-1px); }\r\n  &:active { transform: translateY(0); }\r\n\r\n  &:disabled {\r\n    background: #d4a3af;\r\n    cursor: default;\r\n    transform: none;\r\n  }\n}\n\n.ticket-chat-attach-btn {\n  width: 44px;\n  height: 44px;\n  flex: 0 0 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #e0e2ef;\n  border-radius: 13px;\n  background: $bg;\n  color: $brand;\n  font-size: 1.45rem;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n\n  &:disabled {\n    color: #d4a3af;\n    cursor: default;\n  }\n}\n\n.ticket-chat-selected-files {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.ticket-chat-selected-file {\n  max-width: 100%;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 6px 8px;\n  border-radius: 10px;\n  background: #fff4f7;\n  border: 1px solid #ffd4e2;\n  color: $ink;\n  font-size: .86rem;\n\n  span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  button {\n    width: 22px;\n    height: 22px;\n    border: none;\n    border-radius: 50%;\n    background: #fff;\n    color: $brand;\n    font-weight: 700;\n    cursor: pointer;\n  }\n}\n\n/* ============ micro animations ============ */\n@keyframes bubble-pop {\r\n  from { transform: translateY(4px) scale(.98); opacity: .0; }\r\n  to   { transform: translateY(0) scale(1);    opacity: 1; }\r\n}\r\n\r\n/* ============ utilities ============ */\r\n/* компактнее на низких экранах */\r\n@media (max-height: 680px) {\n  .message-attach-thumb { height: 160px; }\n}\n\n@media (max-width: 480px) {\n  .ticket-chat-input-row {\n    margin-bottom: calc(12px + max(env(safe-area-inset-bottom, 0px), 18px));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
